@if (accountManagersLoading) {
  <div class="overlay full" id="dashboard-loadingSpinner">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<!-- desktop template -->
<div *appIsDesktop>
  @if (!accountManagersLoading) {
    <div class="dashboard-container">
      <div id="accountManagerContainer" class="account-manager-container">
        <ds-paper
          elevation="elevation_none"
          borderRadius="radius_XS"
          outline="outlined"
          insidePaddingTop="top-spacing_L"
          insidePaddingBottom="bottom-spacing_3XS"
          insidePaddingLeft="left-spacing_L"
          insidePaddingRight="right-spacing_XL"
          >
          <div class="section-container">
            <div class="am-container">
              @if (!isAccountManager) {
                <ds-autocomplete
                  #accountManagerAutocomplete
                  id="accountManager"
                  (selectionChange)="onAccountManagerSelect($event)"
                  [options]="accountManagersListDisplay"
                  [label]="appStrings.quoteDetails_AccountManager"
                  label_orientation="vertical-label"
                  [control]="accountManagerForm.controls.accountManager"
                ></ds-autocomplete>
              }
              @if (!isAccountManager && clearFiltersDisplayed) {
                <div class="filters-container-text">
                  <span class="autocomplete-label label-spacer" aria-hidden="true">&nbsp;</span>
                  <div class="filters-row">
                    <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
                    <span id="clearAllFilters" class="clickable" (click)="clearFilters()">
                      {{ appStrings.accounts_clearFilters }}
                    </span>
                  </div>
                </div>
              }
            </div>
            <div class="actions-container" [ngClass]="{'pull-left': isAccountManager}">
              @if (isWarehouseListVisible) {
                <ds-select
                  id="consignedWarehouse"
                  class="warehouse-select"
                  (selectionChange)="onWarehouseSelect($event)"
                  [label]="appStrings.label_consignedWarehouse"
                  [dropOptions]="warehouseList"
                  label_orientation="vertical-label"
                  [control]="accountManagerForm.controls.consignedWarehouse"
                ></ds-select>
              }
              <ds-button size="medium" type="secondary" variant="label-icon" icon="warehouse" [label]="appStrings.label_consignedWarehouseReport" id="consignedWarehouseReport"
                iconPosition="left" iconStyle="material-icons-outlined" (onClick)="printWarehouseReport()" [isDisabled]="consignedReportDisabled"
              ></ds-button>
              <ds-button size="medium" type="secondary" variant="label-icon" icon="insert_chart" [label]="appStrings.button_viewReports" id="viewReports"
                iconPosition="left" iconStyle="material-icons-outlined" (onClick)="handleViewReports()"
              ></ds-button>
            </div>
          </div>
        </ds-paper>
      </div>
      @if (isAccountManager || amEmployeeId) {
        <div id="dailyTouchpointsContainer">
          <app-daily-touchpoints [accountManagerEmployeeId]="amEmployeeId"></app-daily-touchpoints>
        </div>
      }
      <div id="followUpContainer">
        <app-follow-up [accountManagerEmployeeId]="amEmployeeId"></app-follow-up>
      </div>
      @if (isAccountManager || amEmployeeId) {
        <div id="lastTenContainer">
          <app-last-ten [accountManagerEmployeeId]="amEmployeeId"></app-last-ten>
        </div>
      }
    </div>
  }
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  @if (!accountManagersLoading) {
    <div>
      @if (!isAccountManager) {
        <ds-paper
          class="admin-header"
          elevation="elevation_none"
          borderRadius="radius_XS"
          outline="outlined"
          insidePaddingTop="top-spacing_S"
          insidePaddingBottom="bottom-spacing_S"
          insidePaddingLeft="left-spacing_S"
          insidePaddingRight="right-spacing_3XS"
          >
          <ds-autocomplete
            #accountManagerAutocomplete
            id="accountManager"
            (selectionChange)="onAccountManagerSelect($event)"
            [options]="accountManagersListDisplay"
            [control]="accountManagerForm.controls.accountManager"
            label_orientation="horizontal-label"
            class="no-subscript"
            drop_icon="search"
            [fullWidth]="true"
            [placeholder]="appStrings.dashboard_searchAM"
          ></ds-autocomplete>
        </ds-paper>
      }
      @if (!isAccountManager && clearFiltersDisplayed) {
        <div class="mobile-results">
          <span id="clearAllFiltersMobile" class="clickable" (click)="clearFilters()">
            {{ appStrings.accounts_clearFilters }}
          </span>
        </div>
      }
      <div class="title">
        <typography variant="mat-headline-4" weight="bold"> {{ appStrings.menu_Dashboard }}</typography>
      </div>
      @if (isAccountManager || amEmployeeId) {
        <div id="dailyTouchpointsContainer">
          <app-daily-touchpoints [accountManagerEmployeeId]="amEmployeeId"></app-daily-touchpoints>
        </div>
      }
      <div id="followUpContainer">
        <app-follow-up [accountManagerEmployeeId]="amEmployeeId"></app-follow-up>
      </div>
      @if (isAccountManager || amEmployeeId) {
        <div id="lastTenContainer">
          <app-last-ten [accountManagerEmployeeId]="amEmployeeId"></app-last-ten>
        </div>
      }
    </div>
  }
</div>